import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-076ecd50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dk-megamenu__container" }
const _hoisted_2 = { class: "dk-megamenu__item w-full" }
const _hoisted_3 = { class: "pb-20" }
const _hoisted_4 = { class: "grid grid-cols-5" }
const _hoisted_5 = { class: "relative flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MegamenuLocationGroups = _resolveComponent("MegamenuLocationGroups")!
  const _component_SvgWorldMap = _resolveComponent("SvgWorldMap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondLocationGroup, (location) => {
            return (_openBlock(), _createBlock(_component_MegamenuLocationGroups, {
              key: location.order,
              id: location.locationName ? location.locationName : 'europe',
              locationGroup: location,
              onClickLocationLink: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickLocationLink', $event)))
            }, null, 8, ["id", "locationGroup"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_MegamenuLocationGroups, {
            locationGroup: _ctx.firstLocationGroup[0],
            contactFooterNavigationTree: _ctx.contactNavigationTree,
            onClickLocationLink: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clickLocationLink', $event)))
          }, null, 8, ["locationGroup", "contactFooterNavigationTree"]),
          _createVNode(_component_SvgWorldMap, { class: "dk-megamenu__world-map flex-grow text-blue-dark" })
        ])
      ])
    ])
  ]))
}